import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  AlertDialogCloseButton,
  Button,
  ButtonProps,
  ModalProps,
} from '@chakra-ui/react';
import React from 'react';

export interface IConfirmationModalData {
  clickAction: () => void;
  title: string;
  descriptionText?: string | React.ReactNode;
  hideCancelButton?: boolean;
  isDestructive?: boolean;
  buttonName: string;
}

interface IProps {
  isOpen: boolean;
  titleText: string;
  confirmationButtonText: string;
  cancelButtonText?: React.ReactNode;
  id?: string;
  descriptionText?: React.ReactNode;
  hideCancelButton?: boolean;
  isDestructive?: boolean;
  onClickSuccess: () => void;
  onClose: () => void;
  confirmationButtonProps?: Partial<ButtonProps>;
  cancelButtonProps?: Partial<ButtonProps>;
  modalProps?: Partial<ModalProps>;
  withBackdrop?: boolean;
}

const ConfirmationModal: React.FC<IProps> = props => {
  const {
    id = 'agent-view',
    isOpen,
    titleText,
    descriptionText = '',
    confirmationButtonText,
    cancelButtonText = 'Cancel',
    hideCancelButton = false,
    isDestructive,
    onClickSuccess,
    onClose,
    cancelButtonProps = {},
    confirmationButtonProps = {},
    modalProps = {},
    withBackdrop = false,
  } = props;

  const showBody = Boolean(descriptionText?.toString()?.trim());
  const cancelRef = React.useRef<HTMLButtonElement>(null);

  const confirmButtonColorScheme = isDestructive ? 'red' : 'blue';

  return (
    <AlertDialog
      closeOnEsc={false}
      id={id}
      isOpen={isOpen}
      leastDestructiveRef={cancelRef}
      onClose={onClose}
      {...modalProps}
    >
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader data-selector="confirmation-modal-title">
            {titleText}
            {withBackdrop && <AlertDialogCloseButton />}
          </AlertDialogHeader>

          {showBody && <AlertDialogBody data-selector="confirmation-modal-body">{descriptionText}</AlertDialogBody>}

          <AlertDialogFooter>
            {!hideCancelButton && (
              <Button
                id="cancel-button"
                data-selector="confirmation-modal-cancel-button"
                ref={cancelRef}
                onClick={onClose}
                {...cancelButtonProps}
              >
                {cancelButtonText}
              </Button>
            )}

            <Button
              id="confirm-button"
              data-selector="confirmation-modal-confirm-button"
              variant="solid"
              colorScheme={confirmButtonColorScheme}
              onClick={onClickSuccess}
              ml={hideCancelButton ? undefined : 3}
              {...confirmationButtonProps}
            >
              {confirmationButtonText}
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  );
};
export default ConfirmationModal;
